import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SportxxTheme } from '../sportxx';
export const BikeworldTheme = {
  name: 'Bikeworld Theme',
  themeId: 'bikeworld',
  colors: {
    brand: {
      primary: {
        100: '#e6000a',
        90: '#b30008'
      },
      secondary: {
        100: '#b30107'
      },
      accent: {
        100: '#000000'
      },
      negative: {
        100: '#bc0e35'
      },
      positive: {
        100: '#09845e'
      },
      alternative: {
        100: '#000'
      },
      specialRialtoRatingsColor: {
        100: '#333333'
      },
      specialRialtoElementsColor: {
        100: '#333333'
      }
    }
  },
  backgrounds: {
    tile: '#000'
  },
  fonts: _objectSpread({}, SportxxTheme.fonts)
};